import React from 'react';
import ProjectXlsSpecificationModal from './ProjectXlsSpecificationModal';

export default class ProjectXmlSpecificationModal extends ProjectXlsSpecificationModal {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            languageId: null,
            selectedSections: [],
            projectChecked: false,
        }
    }

    executeAction = (data) => {
        return this.configurationAPIService.generateXmlSignLabelData(data)
    }

    getDescription = () => 'Project specification for sign labels';
}